// extracted by mini-css-extract-plugin
export default {"card_header":"CardHeader_card_header__WsYIe","title":"CardHeader_title__fxfaK"};